import React, { useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import useProductName from "brand-customization/useProductName";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import { useStore } from "stores/connect";
import ForwarderDocs from "forwarder/util/ForwarderDocs";
import LicenseCheck from "license/LicenseCheck";
import { LICENSE_SUBJECTS } from "license/constants";
import ForwardersListComponent from "./forwarders/ForwardersListComponent";
import InputProfilesStore, { InputProfilesActions } from "./stores/InputProfilesStore";
import EmptyForwarderListComponent from "./forwarders/EmptyForwarderListComponent";
import ForwardersContext from "./forwarders/ForwardersContext";
import PaginatedForwarderListProvider from "./forwarders/PaginatedForwarderListProvider";
import withIsPermitted from "./util/withIsPermitted";
import ForwarderPageNavigation from "./ForwarderPageNavigation";
const REQUIRED_PERMISSIONS = ["forwarders:read", "inputprofiles:read"];
const ForwardersPage = () => {
  const productName = useProductName();
  const { all: inputProfiles } = useStore(InputProfilesStore);
  useEffect(() => {
    InputProfilesActions.listAll();
  }, []);
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Forwarders" }, /* @__PURE__ */ React.createElement(ForwarderPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Forwarders",
      documentationLink: {
        title: "Forwarder documentation",
        path: ForwarderDocs.FORWARDER
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "List of Forwarders that have registered with this ", productName, " instance.")
  ), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      licenseSubject: LICENSE_SUBJECTS.forwarder,
      displayWarningContainer: true,
      featureName: "Forwarder",
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(PaginatedForwarderListProvider, null, /* @__PURE__ */ React.createElement(ForwardersContext.Consumer, null, ({ forwarders, pagination, changeQuery, changeSort, changeStateFilter, isLoading }) => {
    if (forwarders && inputProfiles && pagination) {
      return forwarders.length === 0 && isEmpty(pagination == null ? void 0 : pagination.query) && (pagination == null ? void 0 : pagination.stateFilter) === "any" ? /* @__PURE__ */ React.createElement(EmptyForwarderListComponent, null) : /* @__PURE__ */ React.createElement(
        ForwardersListComponent,
        {
          forwarders,
          isLoading,
          inputProfiles,
          pagination,
          onQueryChange: changeQuery,
          onSortChange: changeSort,
          onStateFilterChange: changeStateFilter
        }
      );
    }
    return /* @__PURE__ */ React.createElement(Spinner, null);
  })));
};
export default withIsPermitted(ForwardersPage, REQUIRED_PERMISSIONS);
